import moment from 'moment';

import CommunicationSimulator from './communication_simulator';
import Communicator from 'models/communicator';
import Factory from 'factories/all';

export default class IncomingVoicemailSimulator extends CommunicationSimulator {
  constructor({ orgId, publisher, services }, database) {
    super({ attribute: 'incomingVoicemails', createItem: createVoicemailItem, orgId, publisher, services }, database);
  }

  _createRoutingItem(attrs) {
    return Factory.build('RoutingItemForVoicemail', this._getRoutingItemAttrs(attrs));
  }
}

function createVoicemailItem(rawVoicemail) {
  return Factory.build('VoicemailItem', {
    initiator: {
      type: Communicator.CUSTOMER,
      id: rawVoicemail.customerId,
    },
    content: rawVoicemail.content,
    routeAt: moment().format(),
  });
}



// WEBPACK FOOTER //
// ./src/scripts/infrastructure/backends/communication_simulation_service/incoming_voicemail_simulator.js